webpackJsonp([6038130056551],{

/***/ 1352:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ApproveCubexDiagnosticInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"encounterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-approve-cubex-diagnostic-input-f3b6b724f1733c7407f3.js